<template>
    <div ref="container" class="fancybox h-100">
      <slot></slot>
    </div>
  </template>
  
  <script>
  import { Fancybox } from '@fancyapps/ui';
  import './fancybox.css';
  export default {
    name: 'FancyBoxComponent',
    props: {
      options: Object,
    },
    mounted() {
      Fancybox.bind(this.$refs.container, '[data-fancybox]', {
        ...(this.options || {}),
      });
    },
    updated() {
      Fancybox.unbind(this.$refs.container);
      Fancybox.close();
  
      Fancybox.bind(this.$refs.container, '[data-fancybox]', {
        ...(this.options || {}),
      });
    },
    unmounted() {
      Fancybox.destroy();
    },
  }
  </script>
  <style>
  .swiper-gallery {
    position: relative;
  }
  
  .swiper-container {
    max-width: 100vw;
    width: 100%;
    height: 100%;
  }
  
  .swiper-wrapper {
    padding: 0;
    height: calc(100vh - 120px);
  }
  
  .gallery .swiper-slide {
    max-width: 100vw;
    display: flex;
    align-items: center;
  }
  
  .swiper-button-disabled {
    opacity: 0.5;
  }
  
  .gallery .swiper-slide img {
    max-width: 100vw ;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* object-fit: fill; */
    object-position: center;
  }
  .modal-body{
    margin-top:10px
  }
  .swiper-slide-active{
    width: 100% !important;
  }
  
  </style>